// Role changes are separate requests with no batch endpoint, so a set of them can partially
// succeed: callers refresh when anything changed and only report success when everything did.
export const settleRoleChanges = async (changes: Promise<unknown>[]) => {
  const results = await Promise.allSettled(changes)

  return {
    anySucceeded: results.some((result) => result.status === 'fulfilled'),
    allSucceeded: results.every((result) => result.status === 'fulfilled'),
  }
}
